module.exports = __webpack_public_path__ + "img/bookImg2.ee961421.png";